import {
  Avatar,
  Box,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Typography
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { Practitioner } from '../types'
import { PractitionerSessions } from './PractitionerSessions';
import { PractitionerInterests } from './PractitionerInterests';

export function PractitionerDialog({
  omitSession,
  onClose,
  practitioner,
  showSessions,
}: {
  omitSession?: string;
  onClose: () => void;
  practitioner?: Practitioner;
  showSessions?: boolean;
}) {
  return (
    <Dialog
      fullWidth
      maxWidth='md'
      onClose={onClose}
      open={!!practitioner}
      PaperProps={{
        style: {
          backgroundColor: '#a0b1af'
        }
      }}
    >
      <DialogTitle>
        <Typography
          fontSize={22}
        >Practitioner Detail</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Paper
          elevation={0}
          style={{
            padding: 26
          }}
        >
          <Grid
            container
            spacing={2}
          >
            <Grid item
              xs={12}
              md={3}
            >
              <Card>
                <CardContent>
                  <Grid
                    container
                    spacing={2}
                  >
                    <Grid
                      item
                      md={4}
                      xs={12}
                    >
                      <Avatar alt={practitioner?.fullName} />
                    </Grid>
                    <Grid
                      item
                      md={8}
                      xs={12}
                    >
                      <Typography
                        fontWeight={500}
                      >{practitioner?.fullName}</Typography>
                      <Typography
                      >{practitioner?.credentials.join(', ')}</Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid
              item
              md={9}
              xs={12}
            >
              <Box
              >
                <Typography
                  fontWeight={500}
                >Profile Information</Typography>
                <Typography
                  gutterBottom
                >{practitioner?.bio}</Typography>
              </Box>
              <Box>
                <Typography
                  fontWeight={500}
                >Special Interests</Typography>
                <PractitionerInterests
                  practitioner={practitioner}
                />
              </Box>
            </Grid>
            {showSessions &&
              <PractitionerSessions
                guid={practitioner?.guid}
                name={practitioner?.fullName}
                omitSession={omitSession}
              />
            }
          </Grid>
        </Paper>
      </DialogContent>
    </Dialog>
  );
}
